import * as Cookie from 'js-cookie';

// Legacy cookie storing web master product IDs. It is shared with the homepage
// carousel, so its format must stay backwards compatible (do not change it).
const LEGACY_LAST_VISITED_PRODUCTS_COOKIE_KEY = 'lastProds';
// New cookie storing the catalog ID of the actually viewed variant. Used by the
// product detail carousel so it can show the exact viewed variant, not the master.
const LAST_VISITED_VARIANTS_COOKIE_KEY = 'lastProducts';
const LAST_VISITED_PRODUCTS_COOKIE_DIVIDER = '-';
const MAX_COOKIE_ITEMS_COUNT = 16;
const YEAR_DAYS_COUNT = 365;

const getCookie = (key: string) => {
  try {
    return Cookie.get(key);
  } catch (e) {
    return '';
  }
};

const loadFromCookieOldestFirst = (key: string): string[] => {
  const cookie = getCookie(key);
  const ids = cookie?.split(LAST_VISITED_PRODUCTS_COOKIE_DIVIDER);

  if (ids?.length) {
    return ids;
  }

  return [];
};

export const loadProductsFromCookieOldestFirst = (): string[] =>
  loadFromCookieOldestFirst(LEGACY_LAST_VISITED_PRODUCTS_COOKIE_KEY);

// Legacy `lastProds` writer — kept byte-for-byte identical to the original
// behaviour (read first, then remove the shared cookie, then set) because this
// cookie is still consumed by other fragments. This app only writes it now,
// it no longer reads it for the product detail carousel.
export const appendProductToCookie = (productId: string) => {
  const productsWithoutCurrentProduct =
    loadProductsFromCookieOldestFirst().filter((id) => id !== productId);
  const productIds = [...productsWithoutCurrentProduct, productId].slice(
    -1 * MAX_COOKIE_ITEMS_COUNT
  );

  removeOldParfumsCookie();

  Cookie.set(
    LEGACY_LAST_VISITED_PRODUCTS_COOKIE_KEY,
    productIds.join(LAST_VISITED_PRODUCTS_COOKIE_DIVIDER),
    { expires: YEAR_DAYS_COUNT }
  );
};

export const loadVariantsFromCookieOldestFirst = (): string[] =>
  loadFromCookieOldestFirst(LAST_VISITED_VARIANTS_COOKIE_KEY);

export const appendVariantToCookie = (
  catalogId: string,
  productVariantCatalogIds: string[]
) => {
  const productVariantIds = new Set(productVariantCatalogIds);
  // Drop every previously stored variant of the same product so the carousel
  // never shows multiple variants of one product — keep only the last viewed.
  const withoutProductVariants = loadVariantsFromCookieOldestFirst().filter(
    (id) => !productVariantIds.has(id)
  );
  const ids = [...withoutProductVariants, catalogId].slice(
    -1 * MAX_COOKIE_ITEMS_COUNT
  );

  Cookie.set(
    LAST_VISITED_VARIANTS_COOKIE_KEY,
    ids.join(LAST_VISITED_PRODUCTS_COOKIE_DIVIDER),
    { expires: YEAR_DAYS_COUNT }
  );
};

const removeOldParfumsCookie = () => {
  // eg. www.notino.cz
  const hostName = window.location.hostname;
  const allSubDomainsHostName = hostName.replace(/^(www\.)/, '.');

  Cookie.remove(LEGACY_LAST_VISITED_PRODUCTS_COOKIE_KEY, {
    domain: allSubDomainsHostName,
  });
};
